import scrollMonitor from 'scrollmonitor'
import { requestTimeout } from '../util'

const $map = $('.service-map')
const MAX_MAP_DELAY = 1500

const setupScroll = () => {
  const mapWatcher = scrollMonitor.create($map.get(0), $map.height() / 3)

  mapWatcher.fullyEnterViewport(() => {
    requestTimeout(() => {
      $map.find('path, polygon').sort(() => (Math.round(Math.random()) - 0.5)).each((index, el) => {
        const delay = 25 * index

        requestTimeout(() => {
          $(el).addClass('active')
        }, delay)
      })

      mapWatcher.destroy()
    }, 500)
  })
}

export default {
  can: () => $map.length,
  run: () => {
    setupScroll()
  }
}
